import { configureStore } from '@reduxjs/toolkit'
import adminReducer from './adminSlice'
import authReducer from './authSlice'

export const store = configureStore({
  reducer: {
    admin: adminReducer,
    auth: authReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
